import { useLang } from "../../lib/i18n";
import { RateChart } from "./RateChart";

const KEYS = ["rice_husk", "paddy_straw", "wheat_bhusa", "mustard_stalk"];

export const RateBoard = ({ rates }) => {
  const { t, lang } = useLang();
  const names = t("supply.materials");
  const values = rates?.rates ?? {};
  const updated = rates?.updated_at
    ? new Date(rates.updated_at).toLocaleDateString(lang === "hi" ? "hi-IN" : "en-IN", { day: "numeric", month: "short" })
    : null;
  return (
    <div data-testid="rate-board" className="relative overflow-hidden rounded-[24px] border border-[#E8B04B]/40 bg-[#E8B04B]/10 p-6 sm:p-8">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-4">
        <p className="eyebrow !text-[var(--husk)]">{t("rates.title")}</p>
        {updated && <span data-testid="rate-board-updated" className="font-mono text-xs text-[var(--sage)]">{t("rates.updated", { d: updated })}</span>}
      </div>
      {KEYS.map((k) => {
        const v = values[k];
        return (
          <div key={k} data-testid={`rate-row-${k}`} className="flex items-baseline justify-between gap-4 border-t border-[#E8B04B]/20 py-3.5">
            <span className="text-sm sm:text-base">{names[k]}</span>
            {v != null ? (
              <span className="font-display text-xl sm:text-2xl font-bold text-[var(--husk)]">₹{Number(v).toLocaleString("en-IN")}<span className="text-sm font-normal text-[var(--sage)]">{t("rates.perT")}</span></span>
            ) : (
              <span className="font-mono text-sm text-[var(--sage)]">{t("rates.call")}</span>
            )}
          </div>
        );
      })}
      {rates?.note && <p data-testid="rate-board-note" className="mt-3 text-sm text-[var(--cream)]">{rates.note}</p>}
      <p className="mt-3 text-xs text-[var(--sage)]">{t("rates.fine")}</p>
      <RateChart history={rates?.history} />
    </div>
  );
};
